import { CartItem } from '@order/hooks/useCart'
import { usePaymentMethodFee } from '@order/hooks/useInvoiceFee'
import useModalDataState from '@order/hooks/useModalDataState'
import { useRemoteOnlyTotal } from '@order/hooks/useOrderTotal'
import { PaymentDetails } from '@order/hooks/usePayments'
import usePaymentStatusAmounts from '@order/hooks/usePaymentStatusAmounts'
import { usePaymentValues } from '@order/hooks/usePaymentValues'
import StatusInfo from '@screens/payment/status/StatusInfo'
import InstallmentDetails from '@screens/payment/status/installment/InstallmentDetails'
import PaymentDetailsComponent from '@screens/payment/status/prepayment/PaymentDetails'
import { View } from 'react-native'

type ModalContentProps = {
  paymentModal: ReturnType<typeof useModalDataState<PaymentDetails>>
  data: CartItem
}

export default function ModalContent({
  paymentModal,
  data,
}: ModalContentProps) {
  const { payment, result, deals, discounts } = data

  const total = useRemoteOnlyTotal({
    result,
    deals,
  })

  const values = usePaymentValues({
    orderTotal: total,
    discounts,
  })

  const amounts = usePaymentStatusAmounts({
    payment: payment || ({} as PaymentDetails),
    values: values(payment?.method || 'invoice'),
  })

  const { fee } = usePaymentMethodFee(payment?.method)

  return (
    <View className="p-8">
      <View className="mb-8">
        <StatusInfo payment={paymentModal.data} />
      </View>
      {paymentModal.data.method === 'monthly' && (
        <InstallmentDetails amounts={amounts} payment={paymentModal.data} />
      )}
      {paymentModal.data.method !== 'monthly' && (
        <PaymentDetailsComponent
          fee={fee}
          amounts={amounts}
          payment={paymentModal.data}
        />
      )}
    </View>
  )
}
